<template>
  <section
    class="store-results"
    :class="{ 'store-results--loading': isLoading }"
  >
    <ul
      v-if="results.length"
      class="store-results__list"
    >
      <li
        v-for="result in results"
        :key="result.id"
        class="store-results__list-item"
      >
        <Product :product="result" />
      </li>
    </ul>
    <div
      v-if="!results.length"
      class="store-results--empty"
    >
      No results found.
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Product from './Product'

const sortFns = {
  'name': (a, b) => a.sort_name - b.sort_name,
  'price': (a, b) => a.sort_price - b.sort_price,
  'popular': (a, b) => a.sort_popularity - b.sort_popularity
}

export default {
  name: 'Results',

  components: {
    Product
  },

  computed: {
    ...mapState([
      'sort',
      'searchTerm',
      'pagination',
      'isLoading'
    ]),

    results () {
      let results = [...this.$store.state.results]

      if (this.sort !== null) {
        const sortParts = this.sort.split('-')
        const sortType = sortParts[0]
        const sortDir = sortParts[1]
        const sorted = results.sort(sortFns[sortType])

        if (sortDir === 'desc') {
          sorted.reverse()
        }

        results = sorted
      }

      if (this.pagination.viewAll) {
        return results
      }

      const { page, limit } = this.pagination
      const paginatedResults = results.slice((page * limit) - limit, page * limit)

      return paginatedResults
    }
  }
}
</script>
